var _circle, _path, _rect, _rect2, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileDiscard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 48.125,
    r: 13.125,
    stroke: "#7663EB",
    strokeWidth: 8.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 70C89.33 70 105 85.67 105 105H96.25C96.25 90.5025 84.4975 78.75 70 78.75C55.5025 78.75 43.75 90.5025 43.75 105H35C35 85.67 50.67 70 70 70Z",
    fill: "#7663EB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 8.75,
    width: 105,
    height: 118.125,
    rx: 30.625,
    stroke: "#495057",
    strokeWidth: 8.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 12,
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1605_3921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 2,
    width: 36,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.999 36.6668C119.204 36.6668 126.665 29.2052 126.665 20.0002C126.665 10.7952 119.204 3.3335 109.999 3.3335C100.794 3.3335 93.332 10.7952 93.332 20.0002C93.332 29.2052 100.794 36.6668 109.999 36.6668Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.713 15.2861L105.285 24.7145M105.285 15.2861L114.713 24.7145",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1605_3921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 0H130V40H90V0Z",
    fill: "#E8507E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDiscard);
export default __webpack_public_path__ + "static/media/profile-discard.63b3a083870254740ed3e89477c223ee.svg";
export { ForwardRef as ReactComponent };